export class HaltedResponseModel {
    public status = 0;
    public showNotification = false;
    public reason = '';
}